/* ============================================================
   jueves-picante-qv.js — Vista rápida de producto (pop-up) de
   JUEVES DE SERENÉ PICANTE. Solo se carga en esta colección.
   - Toque en foto o nombre de una tarjeta → abre <dialog> (no navega).
     Ctrl/Cmd/Shift/clic medio siguen abriendo el PDP (href intacto).
   - Datos: /products/{handle}.js (cache en memoria; se precarga al tocar).
   - Galería: scroll-snap + flechas + contador; imágenes centradas.
   - Info igual al PDP minimal-product: título, precio, ref, descripción
     repartida por encabezados (Descripción / Notas / A qué huele / Cuándo
     usarlo / Personalidad) + Garantía y Envíos.
   - Único botón: Agregar al carrito (/cart/add.js, sin EasySell). Refresca
     burbuja y drawer; el drawer se abre solo al llegar a 6+ de la colección
     (misma regla que el botón +).
   - Atrás del celular cierra el pop-up (history.pushState sin cambiar URL).
   - Si la carga falla (tras 2 reintentos) muestra aviso con enlace al PDP; no navega sola.
   ============================================================ */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-jp-qv]');
  var root = dlg && dlg.closest('[data-mc-root]');
  if (!dlg || !root || dlg.__jpInit) return;
  dlg.__jpInit = true;
  if (typeof dlg.showModal !== 'function') return; // navegador sin <dialog>: PDP normal

  var OPEN_AT = 6;
  var $ = function (sel) { return dlg.querySelector(sel); };
  var track = $('[data-jp-qv-track]'), prevBtn = $('[data-jp-qv-prev]'), nextBtn = $('[data-jp-qv-next]');
  var counter = $('[data-jp-qv-counter]'), titleEl = $('[data-jp-qv-title]'), priceEl = $('[data-jp-qv-price]');
  var refEl = $('[data-jp-qv-ref]'), descEl = $('[data-jp-qv-desc]'), accsEl = $('[data-jp-qv-accs]');
  var atc = $('[data-jp-qv-atc]'), atcLabel = $('[data-jp-qv-atc-label]');
  var ATC_TXT = dlg.getAttribute('data-atc') || 'Agregar al carrito';
  var CONC = dlg.getAttribute('data-concentration') || 'Extracto de perfume';
  var ids = (document.querySelector('[data-jp-progress]') || {}).getAttribute
    ? document.querySelector('[data-jp-progress]').getAttribute('data-ids') : null;

  var cache = {};
  var current = null;      // { handle, url, variantId }
  var openToken = 0;
  var pushed = false;

  /* ---------- Utilidades ---------- */
  function money(cents) {
    return String(Math.round((cents || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' COP';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getJSON(url, tries) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .catch(function (e) {
        if (tries <= 0) throw e;
        return new Promise(function (res) { setTimeout(res, tries === 2 ? 500 : 1200); })
          .then(function () { return getJSON(url, tries - 1); });
      });
  }
  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = getJSON('/products/' + encodeURIComponent(handle) + '.js', 2) // 2 reintentos (503/red)
        .catch(function (e) { delete cache[handle]; throw e; });
    }
    return cache[handle];
  }

  /* ---------- Descripción (mismo parseo que minimal-product.js) ---------- */
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[:\s]+$/, '').trim();
  }
  var HEADER_MAP = { 'descripcion': 'desc', 'notas olfativas': 'notas', 'notas': 'notas', 'a que huele': 'smell', 'cuando usarlo': 'uso', 'personalidad': 'personalidad' };
  function parseDescription(html) {
    var out = { desc: '', notas: [], smell: '', uso: '', personalidad: '', raw: '' };
    var box = document.createElement('div');
    box.innerHTML = html || '';
    box.querySelectorAll('script,style,iframe').forEach(function (n) { n.remove(); });
    var current = null, found = false;
    function add(key, h) {
      if (!h) return;
      if (key === 'notas') { out.notas.push(h); return; }
      out[key] = out[key] ? out[key] + ' ' + h : h;
    }
    Array.prototype.forEach.call(box.childNodes, function (node) {
      if (node.nodeType !== 1) {
        if (current && node.nodeType === 3 && node.textContent.trim()) add(current, esc(node.textContent.trim()));
        return;
      }
      var strong = node.querySelector ? node.querySelector('strong, b') : null;
      if (strong && /:\s*$/.test(strong.textContent)) {
        current = HEADER_MAP[norm(strong.textContent)] || null;
        if (current) found = true;
        var clone = node.cloneNode(true);
        var s = clone.querySelector('strong, b'); if (s) s.remove();
        var rest = clone.innerHTML.replace(/^\s*(<br\s*\/?>)+/i, '').trim();
        if (current && rest) add(current, rest);
      } else if (current) {
        if (node.tagName === 'UL' || node.tagName === 'OL') {
          Array.prototype.forEach.call(node.querySelectorAll('li'), function (li) { out.notas.push(li.innerHTML.trim()); });
        } else {
          add(current, node.innerHTML ? node.innerHTML.trim() : esc(node.textContent.trim()));
        }
      }
    });
    if (!found) {
      // Formato texto plano: «Encabezado:<br>valor<br>…» (sin negritas)
      var lines = (box.innerHTML || '')
        .replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h\d)>/gi, '\n')
        .replace(/<[^>]+>/g, '').split('\n');
      var tmp = document.createElement('textarea');
      var cur = null;
      lines.forEach(function (raw) {
        tmp.innerHTML = raw; var line = tmp.value.trim();
        if (!line) return;
        var m = /^([^:]{2,30}):\s*(.*)$/.exec(line);
        if (m && HEADER_MAP[norm(m[1])]) {
          cur = HEADER_MAP[norm(m[1])]; found = true;
          if (m[2]) add(cur, esc(m[2]));
        } else if (cur === 'notas') {
          out.notas.push(m ? '<strong>' + esc(m[1]) + ':</strong> ' + esc(m[2]) : esc(line));
        } else if (cur) {
          add(cur, esc(line));
        }
      });
    }
    if (!found) out.raw = box.innerHTML.trim(); // descripción sin encabezados: se muestra tal cual
    return out;
  }
  function accHTML(title, body, open) {
    return '<details class="jp-qv__acc"' + (open ? ' open' : '') + '><summary class="jp-qv__acc-head"><span>' + esc(title) +
      '</span><span class="jp-qv__acc-icon" aria-hidden="true"></span></summary><div class="jp-qv__acc-body">' + body + '</div></details>';
  }

  /* ---------- Galería ---------- */
  var nImgs = 0;
  function renderGallery(images, alt) {
    nImgs = images.length;
    track.innerHTML = images.map(function (img, i) {
      var src = typeof img === 'string' ? img : img.src;
      return '<div class="jp-qv__slide"><img src="' + esc(sized(src, 900)) + '" srcset="' + esc(sized(src, 600)) + ' 600w, ' +
        esc(sized(src, 900)) + ' 900w, ' + esc(sized(src, 1200)) + ' 1200w" sizes="(min-width: 900px) 480px, 100vw" alt="' +
        esc(alt) + (nImgs > 1 ? ' — imagen ' + (i + 1) + ' de ' + nImgs : '') + '"' + (i === 0 ? ' fetchpriority="high"' : ' loading="lazy"') + ' draggable="false"></div>';
    }).join('');
    track.scrollLeft = 0;
    updateNav();
  }
  function idx() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  function updateNav() {
    var i = idx(), multi = nImgs > 1;
    prevBtn.hidden = nextBtn.hidden = counter.hidden = !multi;
    prevBtn.disabled = i <= 0;
    nextBtn.disabled = i >= nImgs - 1;
    counter.textContent = multi ? (i + 1) + ' / ' + nImgs : '';
  }
  function go(d) {
    var i = Math.max(0, Math.min(nImgs - 1, idx() + d));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  prevBtn.addEventListener('click', function () { go(-1); });
  nextBtn.addEventListener('click', function () { go(1); });
  var navRaf;
  track.addEventListener('scroll', function () { cancelAnimationFrame(navRaf); navRaf = requestAnimationFrame(updateNav); }, { passive: true });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft' && nImgs > 1) { e.preventDefault(); go(-1); }
    if (e.key === 'ArrowRight' && nImgs > 1) { e.preventDefault(); go(1); }
  });

  /* ---------- Render ---------- */
  function setLoading(card) {
    var img = card.querySelector('.mc-card__img--main');
    renderGallery(img ? [img.currentSrc || img.src] : [], '');
    titleEl.textContent = (card.querySelector('.mc-card__name') || {}).textContent || '';
    var now = card.querySelector('.mc-card__now');
    priceEl.innerHTML = now ? '<span class="jp-qv__now">' + esc(now.textContent) + '</span>' : '';
    refEl.textContent = '';
    descEl.innerHTML = '<span class="jp-qv__skel"></span><span class="jp-qv__skel"></span><span class="jp-qv__skel jp-qv__skel--short"></span>';
    accsEl.innerHTML = '';
    atc.disabled = true;
    atcLabel.textContent = ATC_TXT;
    dlg.classList.add('is-loading');
  }
  function render(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    current.variantId = v.id;
    var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src || (m.preview_image && m.preview_image.src); });
    if (!imgs.length) imgs = p.images || [];
    renderGallery(imgs, p.title);
    titleEl.textContent = p.title;
    var cmp = v.compare_at_price && v.compare_at_price > v.price;
    priceEl.innerHTML = '<span class="jp-qv__now">' + money(v.price) + '</span>' + (cmp ? '<s class="jp-qv__compare">' + money(v.compare_at_price) + '</s>' : '');

    var code = '';
    var after = (p.title || '').split('Parfum ');
    if (after.length > 1) code = after[after.length - 1].split(' ')[0];
    else code = ((p.title || '').split(' ')[1] || '');
    if (!/^S\d/i.test(code) || code.length > 5) code = '';
    refEl.textContent = (code ? code + ' | ' : '') + '100 ML | ' + CONC;

    var d = parseDescription(p.description);
    descEl.innerHTML = d.raw ? '<div class="jp-qv__rte">' + d.raw + '</div>' : (d.desc ? '<p>' + d.desc + '</p>' : '');
    var accs = '';
    var notas = d.notas.map(function (l) { return '<p class="jp-qv__note">' + l + '</p>'; }).join('') +
      (d.smell ? '<p class="jp-qv__note"><strong>A qué huele:</strong> ' + d.smell + '</p>' : '');
    if (notas) accs += accHTML('Notas olfativas', notas, true);
    var uso = (d.uso ? '<p>' + d.uso + '</p>' : '') + (d.personalidad ? '<p>' + d.personalidad + '</p>' : '');
    if (uso) accs += accHTML('Cuándo usarlo', uso, false);
    dlg.querySelectorAll('template[data-jp-qv-extra]').forEach(function (t) {
      if (t.innerHTML.trim()) accs += accHTML(t.getAttribute('data-title'), t.innerHTML, false);
    });
    accsEl.innerHTML = accs;

    atc.disabled = !v.available;
    atcLabel.textContent = v.available ? ATC_TXT : 'Agotado';
    dlg.classList.remove('is-loading');
  }

  /* ---------- Abrir / cerrar ---------- */
  function open(card, link) {
    var href = link.getAttribute('href');
    var handle = handleFromHref(href);
    if (!handle) { window.location.href = href; return; }
    current = { handle: handle, url: href, variantId: null };
    var token = ++openToken;
    setLoading(card);
    if (!dlg.open) {
      dlg.showModal();
      document.documentElement.classList.add('jp-qv-lock');
      try { history.pushState({ jpqv: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    }
    dlg.querySelector('.jp-qv__body').scrollTop = 0;
    dlg.querySelector('.jp-qv__info').scrollTop = 0;
    fetchProduct(handle).then(function (p) {
      if (token === openToken && dlg.open) render(p);
    }).catch(function () {
      // No navega sola: muestra aviso con enlace opcional al producto
      if (token !== openToken || !dlg.open) return;
      dlg.classList.remove('is-loading');
      descEl.innerHTML = '<p class="jp-qv__error">No pudimos cargar la información en este momento. <a href="' + esc(href) + '">Ver producto</a></p>';
      atc.disabled = true;
    });
  }
  function close(skipHistory) {
    if (!dlg.open) return;
    openToken++;
    dlg.classList.add('is-closing');
    var done = function () {
      dlg.classList.remove('is-closing');
      if (dlg.open) dlg.close();
      document.documentElement.classList.remove('jp-qv-lock');
    };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done(); else setTimeout(done, 200);
    if (pushed && !skipHistory) { pushed = false; try { history.back(); } catch (e) {} }
    pushed = skipHistory ? false : pushed;
  }
  window.addEventListener('popstate', function () {
    if (dlg.open) { pushed = false; close(true); }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); }); // Esc
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) close(); // clic en el fondo (fuera del panel)
  });
  $('[data-jp-qv-close]').addEventListener('click', function () { close(); });

  /* ---------- Interceptar foto / nombre de las tarjetas ---------- */
  var LINK_SEL = '.mc-card__media, .mc-card__name';
  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest ? e.target.closest(LINK_SEL) : null;
    if (!link || !root.contains(link) || dlg.contains(link)) return;
    var card = link.closest('[data-mc-card]');
    if (!card) return;
    e.preventDefault();
    open(card, link);
  });
  /* Precarga al empezar el toque: los datos suelen estar listos al soltar */
  root.addEventListener('pointerdown', function (e) {
    var link = e.target.closest ? e.target.closest(LINK_SEL) : null;
    if (!link || dlg.contains(link)) return;
    var h = handleFromHref(link.getAttribute('href'));
    if (h) fetchProduct(h).catch(function () {});
  }, { passive: true });

  /* ---------- Agregar al carrito (mismo patrón que el botón +) ---------- */
  function refreshSections(sections) {
    try {
      if (sections && sections['cart-icon-bubble']) {
        var p = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var t = document.getElementById('cart-icon-bubble');
        var s = p.querySelector('#shopify-section-cart-icon-bubble') || p.querySelector('.shopify-section');
        if (t && s) t.innerHTML = s.innerHTML;
      }
      if (sections && sections['cart-drawer']) {
        var p2 = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var t2 = document.querySelector('cart-drawer');
        var s2 = p2.querySelector('cart-drawer');
        if (t2 && s2) { t2.classList.toggle('is-empty', s2.classList.contains('is-empty')); t2.innerHTML = s2.innerHTML; }
      }
    } catch (e) {}
  }
  function countOf(cart) {
    if (!ids) return 0;
    var n = 0;
    (cart.items || []).forEach(function (it) { if (ids.indexOf(',' + it.product_id + ',') !== -1) n += it.quantity; });
    return n;
  }
  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') d.open(); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  atc.addEventListener('click', function () {
    if (!current || !current.variantId || atc.disabled || atc.classList.contains('is-loading')) return;
    atc.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: current.variantId, quantity: 1, sections: 'cart-icon-bubble,cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { return Promise.reject(j); }); })
      .then(function (data) {
        refreshSections(data.sections);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        atc.classList.remove('is-loading');
        atc.classList.add('is-added');
        atcLabel.textContent = 'Agregado ✓';
        var n = countOf(cart);
        setTimeout(function () {
          atc.classList.remove('is-added');
          atcLabel.textContent = ATC_TXT;
          close();
          if (n >= OPEN_AT) setTimeout(openDrawer, 260);
          else {
            var cb = document.querySelector('[data-jp-cart]');
            if (cb) { cb.classList.remove('is-nudge'); void cb.offsetWidth; cb.classList.add('is-nudge'); }
          }
        }, 900);
      })
      .catch(function (err) {
        atc.classList.remove('is-loading');
        atcLabel.textContent = (err && err.description) ? 'No disponible' : ATC_TXT;
        setTimeout(function () { atcLabel.textContent = ATC_TXT; }, 2200);
      });
  });
})();
